import { AnyAction } from 'redux';
import { handleActions } from 'redux-actions';

import { logoutAction } from '@reducers/auth/AuthActionConfig';

import {
  getReferralsCountAction,
  getLabOrdersCountAction,
  setHasRedirectToPackagesAction,
  setDashboardFilterAction,
} from './DashboardActionConfig';

// reducers
const defaultState = {
  referralsCount: {},
  labOrdersCount: {},
  hasRedirectToPackages: false,
  filter: {
    label: '',
    value: {
      start_date: '',
      end_date: '',
      custom: false,
      // ENH-034: All Time has no dates, unlike a period not picked yet.
      all_time: false,
    },
  },
};

type State = typeof defaultState;

const reducer = handleActions<State, AnyAction>({
  [`${getReferralsCountAction}`](state, { payload: rawPayload }: AnyAction) {
    // Phase 3 (backend): referrals/count now answers {data: {...}} instead of it directly.
    const payload = rawPayload?.data ?? rawPayload;
    return {
      ...state,
      referralsCount: payload,
    };
  },
  [`${getLabOrdersCountAction}`](state, { payload: rawPayload }: AnyAction) {
    // Phase 3 (backend): lab-orders/count now answers {data: {...}} instead of it directly.
    const payload = rawPayload?.data ?? rawPayload;
    return {
      ...state,
      labOrdersCount: payload,
    };
  },
  [`${setHasRedirectToPackagesAction}`](state: State, { payload }: AnyAction) {
    return {
      ...state,
      hasRedirectToPackages: payload,
    };
  },
  [`${setDashboardFilterAction}`](state: State, { payload }: AnyAction) {
    return {
      ...state,
      filter: {
        label: payload?.label || '',
        value: {
          start_date: payload?.value?.start_date || '',
          end_date: payload?.value?.end_date || '',
          custom: payload?.value?.custom ?? false,
          all_time: payload?.value?.all_time ?? false,
        },
      },
    };
  },
  [`${logoutAction}`](state) {
    return {
      ...state,
      referralsCount: {},
      labOrdersCount: {},
      hasRedirectToPackages: false,
      filter: {
        label: '',
        value: {
          start_date: '',
          end_date: '',
          custom: false,
          all_time: false,
        },
      },
    };
  },
}, defaultState);

export default reducer;
